import React from 'react';
import { translate, nf } from '~/utils';
import { margin } from '~/../config.json';
import { ChartLine, ChartLabel } from './ChartComponents';
import useStore from '../../store';

const selector = (s) => ({ leftColumnsLabel: s.leftColumnsLabel, rightColumnsLabel: s.rightColumnsLabel });

export default function XAxis({ width, height, xScale }) {
  const tickCount = width < 500 ? 2 : 4;
  const ticks = xScale.ticks(tickCount);
  const { leftColumnsLabel, rightColumnsLabel } = useStore(selector);

  return (
    <g transform={translate(0, height)}>
      <g transform={translate(width / 2 + margin.center, 0)}>
        {ticks.map((tick) => (
          <g transform={translate(xScale(tick), 0)}>
            <ChartLine dashed x1={0} x2={0} y1={-height} y2={6} />
            <ChartLabel x={0} y={18} textAnchor="middle">
              {nf(tick)}
            </ChartLabel>
          </g>
        ))}
        <ChartLabel textAnchor="end" x={width / 2} y={34}>
          {rightColumnsLabel} →
        </ChartLabel>
      </g>
      <g>
        {ticks.map((tick) => (
          <g transform={translate(width / 2 - xScale(tick), 0)}>
            <ChartLine dashed x1={0} x2={0} y1={-height} y2={6} />
            <ChartLabel x={0} y={18} textAnchor="middle">
              {nf(tick)}
            </ChartLabel>
          </g>
        ))}
        <ChartLabel y={34}>← {leftColumnsLabel}</ChartLabel>
      </g>
    </g>
  );
}
